import React from 'react'
import styled from 'styled-components'

import { gaEvents } from '@/utils/ga-events'

export const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: InterFace;
  font-weight: bold;
  font-size: 15px;
  color: #fff;
  background: ${({ theme }) => theme.palette.giphyIndigo};
  height: 36px;
  width: 348px;
  margin: 10px auto;
`

// add in link
export const CreateAppButton = () => (
  <Button href="/dashboard/?create=true" onClick={gaEvents.createNewApp}>
    Create an App
  </Button>
)
